import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDocumentFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDocumentFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '98501142a42a3c41edc93355d0f54461b702813f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e8e23fd9e4c34d4927b31226fba5084210d5e165', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'dc94bde984c92138935f28c438f0f684bc9d6ba4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18 18.5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5h7.91a.5.5 0 0 1 .36.15l4.08 4.07a.47.47 0 0 1 .15.35zm-5-14L16.5 8h-3a.5.5 0 0 1-.5-.5zM8 15a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm.5-4a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-document-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-document-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-document-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDocumentFilled$1);
            }
            break;
    } });
}

const CosmosIconDocumentFilled = CosmosIconDocumentFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDocumentFilled, defineCustomElement };
